<template>
  <div v-if="current">
    <v-card width="100%">
      <v-card-title>Dados do registro</v-card-title>
      <v-card-text>
        <v-form>
          <div class="row">
            <div class="col-md-9 col-sm-1">
              <v-text-field label="Nome" v-model="current.name" outlined dense disabled></v-text-field>
            </div>
            <div class="col-md-3 col-sm-1">
              <v-text-field label="Preço" v-model="current.price" outlined dense disabled></v-text-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 col-sm-1">
              <v-text-field label="Download" v-model="current.download" outlined dense disabled></v-text-field>
            </div>
            <div class="col-md-6 col-sm-1">
              <v-text-field label="Upload" v-model="current.upload" outlined dense disabled></v-text-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 col-sm-1">
              <v-textarea label="Observação" v-model="current.obs" outlined dense disabled></v-textarea>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 col-sm-1">
              <v-text-field label="Compels SCI" v-model="current.compelsSCI" outlined dense disabled></v-text-field>
            </div>
            <div class="col-md-6 col-sm-1">
              <v-text-field label="Compels SCM" v-model="current.compelsSCM" outlined dense disabled></v-text-field>
            </div>
          </div>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <div>
          <v-btn
            color="primary"
            @click="dialogPrice()"
            class="ma-2"
            >Alterar preço</v-btn>
          <v-btn
            color="primary"
            @click="dialogCompels()"
            class="ma-2"
            >Alterar compels</v-btn>
        </div>
      </v-card-actions>
    </v-card>

    <v-dialog v-model="dialog_price" max-width="500px">
      <v-card>
        <v-card-title>Alterar Preço</v-card-title>
        <v-card-text>
          <div class="col-md-12 col-sm-1">
            <v-text-field
              label="Preço"
              v-model="changed.price"
              outlined
              dense
            ></v-text-field>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" @click="putPrice()">Salvar</v-btn>
          <v-btn color="default" @click="dialog_price = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_compels" max-width="500px">
      <v-card>
        <v-card-title>Alterar Compels</v-card-title>
        <v-card-text>
          <div class="col-md-12 col-sm-1">
            <v-text-field
              label="Compels SCI"
              v-model="changed.compelsSCI"
              outlined
              dense
            ></v-text-field>
          </div>
          <div class="col-md-12 col-sm-1">
            <v-text-field
              label="Compels SCM"
              v-model="changed.compelsSCM"
              outlined
              dense
            ></v-text-field>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" @click="putCompels()">Salvar</v-btn>
          <v-btn color="default" @click="dialog_compels = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_loading" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Por favor aguarde
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import api from "../../api/index.js";
export default {
  data: () => ({
    current: null,
    changed: {
      price: null
    },
    dialog_loading: false,
    dialog_compels: false,
    dialog_price: false
  }),
  created: function() {
    this.load();
  },
  methods: {
    load: function() {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .get("/plan/" + this.$route.params.id, {
          headers: { Authorization: "Bearer " + token }
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao recuperar registro!");
          console.log(error);
        });
    },
    dialogPrice: function () {
      this.changed.price = this.current.price;
      this.dialog_price = true;
    },
    putPrice: function () {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .put("/plan/price/" + this.$route.params.id, this.changed, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.dialog_price = false;
          alert("Preço alterado com sucesso!");
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao alterar preço!");
          console.log(error);
        });
    },
    dialogCompels: function () {
      this.changed.compelsSCI = this.current.compelsSCI;
      this.changed.compelsSCM = this.current.compelsSCM;
      this.dialog_compels = true;
    },
    putCompels: function () {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .put("/plan/compels/" + this.$route.params.id, this.changed, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.dialog_compels = false;
          alert("Compels alterado com sucesso!");
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao alterar compels!");
          console.log(error);
        });
    },
  }
};
</script>